<template>
  <li>
    <a class="hover-item" @click="toggle">
      Menu
      <span class="icon">
        <i class="fas fa-bars"></i>
      </span>
    </a>
  </li>
</template>

<script>
export default {
  methods: {
    toggle(event) {
      event.preventDefault()
      this.$store.commit('sidebar/toggle')
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'assets/stylesheets/main.scss';

a {
  line-height: 70px;
  border-bottom: 1px solid $light-grey;
  padding-left: 25px;
  font-weight: 500;
  display: block;
  font-size: 18px;

  &.router-link-active {
    color: $dark-primary;
    background: $light-secondary;
  }
}

.icon {
  float: right;
  display: inline-block;
  width: 70px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/sidebar/toggle.vue